import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_URL = BASE_URL.endsWith('/api/v1') ? BASE_URL : BASE_URL + '/api/v1';

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

export const authService = {
  async signUp(phone: string, fullName: string, email?: string, agentCode?: string) {
    const res = await api.post('/auth/signup', { phone, fullName, email, role: 'customer', agentCode });
    return res.data;
  },
  /** Check a marketing agent's code before the account exists. */
  async checkAgentCode(code: string): Promise<{ valid: boolean; agentName?: string }> {
    try {
      const res = await api.get(`/auth/agent-code/${encodeURIComponent(code)}`);
      return res.data;
    } catch {
      return { valid: false };
    }
  },
  async requestOTP(phone: string) {
    const res = await api.post('/auth/request-otp', { phone });
    return res.data;
  },
  async verifyOTP(phone: string, otp: string, sessionId: string) {
    const res = await api.post('/auth/verify-otp', { phone, otp, sessionId });
    return res.data;
  },
};
